import { Box } from '@wishket/design-system';
import { use } from 'react';

import NewLandingArticleItem from '../NewLandingArticle/NewLandingArticleItem';

import { NewLandingArticleItemProps } from '@/shared/types';
interface MostScrappedContentsProps {
  contentsPromise: Promise<NewLandingArticleItemProps[]>;
}

const MostScrappedContents = ({
  contentsPromise,
}: MostScrappedContentsProps) => {
  const mainContent = use(contentsPromise);

  return (
    <Box
      className="grid grid-cols-1 gap-5 tablet:grid-cols-2 desktop:gap-x-[77px] desktop:gap-y-8"
      data-testid="landing-scrap-contents-list"
    >
      {mainContent.map((content) => {
        const itemProps = {
          ...content,
          titleClassName: 'tablet:typo-subTitle2',
          articleCountTypoClassName: 'tablet:typo-subTitle2',
        };

        return (
          <Box key={content.articleInfo.id}>
            <Box className="hidden tablet:block">
              <NewLandingArticleItem {...itemProps} imageSize="md" />
            </Box>
            <Box className="tablet:hidden">
              <NewLandingArticleItem {...itemProps} imageSize="sm" />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default MostScrappedContents;
